<template>
	<div>
		<!-- 顶部 -->
		<div class="header-body">
			<Button type="info" @click="add">添加</Button>
		</div>
		<Divider />
		<!-- table -->
		<Table :columns="columns" :data="data" border height="700"></Table>

		<!-- 朝代 -->
		<Modal v-model="addShow" :title="addTitle" width="1300" :mask-closable="false">
			<Form ref="formData" :model="formData" :rules="ruleFormData" :label-width="80">
				<Row>
					<Col span="8">
						<FormItem label="名称" prop="title">
							<Input v-model="formData.title" placeholder="请输入朝代名称" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="建立者" prop="founder">
							<Input v-model="formData.founder" placeholder="请输入朝代建立者" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="头像">
							<Uploads v-if="addShow" :images="formData.head_img" @send-img="getImg"></Uploads>
						</FormItem>
						<FormItem label="父级" prop="parent_id">
							<Select :disabled="parentEdit == 1" v-model="formData.parent_id" placeholder="请选择父级" style="width: 200px;">
								<Option v-for="(item,index) in data" :key="index" :value="item.id">
									{{item.title}}
								</Option>
							</Select>
						</FormItem>
						<FormItem label="时间线" prop="year">
							<Input v-model="formData.year" placeholder="请输入朝代时间线" style="width: 300px;"></Input>
						</FormItem>
						<FormItem label="都城" prop="old_area">
							<Input v-model="formData.old_area" type="textarea" style="width: 300px;" :rows="4" placeholder="请输入朝代都城..." />
						</FormItem>
						<FormItem label="现地址" prop="now_area">
							<Input v-model="formData.now_area" type="textarea" style="width: 300px;" :rows="4" placeholder="请输入朝代现地址..." />
						</FormItem>
					</Col>
					<Col span="16">
						<FormItem label="简介" prop="desc">
							<Input v-model="formData.desc" type="textarea" style="width: 700px;" :rows="4" placeholder="请输入朝代简介..." />
						</FormItem>
						<FormItem label="详情" prop="content">
							<editor v-if="addShow" :html="formData.content" @send-html="getHtml"></editor>
						</FormItem>
					</Col>
				</Row>

			</Form>

			<div slot="footer">
				<Button type="default" @click="addShow = false;">取消</Button>
				<Button type="primary" @click="submit">提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import Editor from '@/components/Editor'
	import Uploads from '@/components/Uploads'
	import { getDynasty, addDynasty, getDynastyDetail, editDynasty, deleteDynasty } from '@/utils/wenxue.js'
	export default {
		name: 'Chaodai',
		components: {
			Editor,
			Uploads
		},
		data() {
			return {
				data: [],
				columns: [{
						type: 'expand',
						width: 80,
						render: (h, param) => {
							if(param.row.child.length == 0) {
								return false;
							}
							return h('Table', {
								props: {
									'show-header': false,
									data: param.row.child,
									columns: [{
											title: '朝代名称',
											minWidth: 150,
											align: 'left',
											key: 'title'
										},
										{
											title: '时间线',
											minWidth: 240,
											align: 'left',
											key: 'year'
										},
										{
											title: '建立者',
											minWidth: 120,
											align: 'left',
											key: 'founder'
										},
										{
											title: '都城',
											minWidth: 240,
											align: 'left',
											key: 'old_area'
										},
										{
											title: '现地址',
											minWidth: 240,
											align: 'left',
											key: 'now_area'
										},
										{
											title: '操作',
											minWidth: 200,
											align: 'center',
											render: (h, param) => {
												var _that = this;
												return h('div', [
													h('Button', {
														props: {
															type: 'primary',
															size: 'small'
														},
														style: {
															marginRight: '6px'
														},
														on: {
															'click': function() {
																_that.parentEdit = 0;
																_that.formData.id = param.row.id;
																_that.getDynastyDetail();
															}
														}
													}, '编辑'),
													h('Button', {
														props: {
															type: 'error',
															size: 'small'
														},
														style: {

														},
														on: {
															'click': function() {
																_that.$Modal.confirm({
																	title: '删除确认',
																	content: '该操作不可逆，是否确认删除？',
																	onOk: function() {
																		deleteDynasty({
																			id: param.row.id
																		}).then(res => {
																			let index = null;
																			_that.data.forEach((e, key) => {
																				if(e.id == res) {
																					index = key;
																				}
																			})

																			if(index !== null) _that.data.splice(index, 1);
																		})
																	}
																})
															}
														}
													}, '删除')
												])
											}
										}
									]
								}
							})
						}
					},
					{
						title: '朝代名称',
						minWidth: 150,
						align: 'left',
						key: 'title'
					},
					{
						title: '时间线',
						minWidth: 240,
						align: 'left',
						key: 'year'
					},
					{
						title: '建立者',
						minWidth: 120,
						align: 'left',
						key: 'founder'
					},
					{
						title: '都城',
						minWidth: 240,
						align: 'left',
						key: 'old_area'
					},
					{
						title: '现地址',
						minWidth: 240,
						align: 'left',
						key: 'now_area'
					},
					{
						title: '操作',
						minWidth: 200,
						align: 'center',
						render: (h, param) => {
							var _that = this;
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '6px'
									},
									on: {
										'click': function() {
											_that.parentEdit = 1;
											_that.formData.id = param.row.id;
											_that.getDynastyDetail();
										}
									}
								}, '编辑'),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {

									},
									on: {
										'click': function() {
											_that.$Modal.confirm({
												title: '删除确认',
												content: '该操作不可逆，是否确认删除？',
												onOk: function() {
													deleteDynasty({
														id: param.row.id
													}).then(res => {
														let index = null;
														_that.data.forEach((e, key) => {
															if(e.id == res) {
																index = key;
															}
														})

														if(index !== null) _that.data.splice(index, 1);
													})
												}
											})
										}
									}
								}, '删除')
							])
						}
					}
				],
				addShow: false,
				addTitle: '添加朝代',
				formData: {
					id: 0,
					parent_id: 0,
					title: '',
					year: '',
					head_img: [],
					old_area: '',
					now_area: '',
					founder: '',
					desc: '',
					content:''
				},
				ruleFormData: {
					title: [{
						required: true,
						message: '请输入朝代名称',
						trigger: 'blur'
					}],
					year: [{
						required: true,
						message: '请输入朝代时间线',
						trigger: 'blur'
					}],
					founder: [{
						required: true,
						message: '请输入朝代建立者',
						trigger: 'blur'
					}]
				},
				parentEdit: 0,
			}
		},
		methods: {
			async getList() {
				const data = await getDynasty();

				this.data = data;
			},
			add() {
				this.addShow = true;
				this.addTitle = '添加朝代';
				this.parentEdit = 0;

				this.$refs['formData'].resetFields();

				this.formData.id = 0;
				this.formData.parent_id = 0;
				this.formData.title = '';
				this.formData.year = '';
				this.formData.head_img = [];
				this.formData.old_area = '';
				this.formData.now_area = '';
				this.formData.founder = '';
				this.formData.desc = '';
				this.formData.content = '';
			},
			getHtml(html) {
				this.formData.content = html;
			},
			getImg(img) {
				this.formData.head_img = img;
			},
			submit() {
				var _that = this;
				this.$refs['formData'].validate((valid) => {
					if(valid) {
						const param = { ..._that.formData
						};

						if(param.id > 0) {
							editDynasty({
								form: param
							}).then((res) => {
								_that.$Message.info('编辑成功');
								_that.addShow = false;
								_that.getList();
							})
						} else {
							addDynasty({
								form: param
							}).then((res) => {
								_that.$Message.info('添加成功');
								_that.addShow = false;
								_that.getList();
							})
						}
					}
				})
			},
			getDynastyDetail() {
				getDynastyDetail({
					id: this.formData.id
				}).then((res) => {
					this.addShow = true;
					this.addTitle = '编辑朝代';
					this.formData = { ...res
					};
				})
			}
		},
		mounted() {
			this.getList();
		}
	}
</script>

<style scoped>
	.ivu-layout {
		height: 100vh !important;
	}
	
	.header-body {
		width: 100%;
		min-height: 36px;
		display: flex;
		align-items: center;
	}
	
	.ivu-divider-horizontal {
		margin: 12px !important;
	}
</style>


// WEBPACK FOOTER //
// src/views/wenxue/Chaodai.vue